import React, { useMemo } from "react";
import { Card, CircularProgress, Grid } from "@mui/material";

import { IoBusiness, IoLocationSharp } from "react-icons/io5";

import { FaClipboardList, FaHouseUser, FaPlaneArrival, FaPlaneDeparture } from "react-icons/fa";

import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import HotelSelector from "components/HotelSelector";

import useCommon from "hooks/useCommon";
import KpiCard from "components/KpiCard";

function DashboardPropertyHeader() {
  const { STORE, NAVIGATE } = useCommon();

  const { counters, countersLoading } = STORE((state) => state.dashboard);

  const selectedHotelId = STORE((state) => state.ui.hotelId);

  const hotels = STORE((state) => state.ui.hotels);

  const selectedHotel = useMemo(() => {
    return hotels?.find((h) => h._id === selectedHotelId);
  }, [hotels, selectedHotelId]);

  const kpis = [
    {
      title: "Today's Arrivals",
      value: counters?.todayArrivals || 0,
      color: "success",
      icon: <FaPlaneArrival size={16} />,
      route: "/arrivals&departures",
    },
    {
      title: "Today's Departures",
      value: counters?.todayDepartures || 0,
      color: "error",
      icon: <FaPlaneDeparture size={16} />,
      route: "/arrivals&departures?tab=departures",
    },
    {
      title: "Active Stays",
      value: counters?.activeStays || 0,
      color: "success",
      icon: <FaHouseUser size={16} />,
      route: "/inHouseGuests",
    },
    {
      title: "Due Requests",
      value: counters?.dueRequests?.total || 0,
      // sub: counters?.dueRequests?.pending > 0 ? `${counters?.dueRequests?.pending} pending` : null,
      color: "warning",
      icon: <FaClipboardList size={16} />,
      route: "/requests",
    },
  ];

  return (
    <Card sx={{ py: 2, px: 1 }}>
      <VuiBox px={1} py={0}>
        <Grid container spacing={2} alignItems="stretch">
          <Grid item xs={12} lg={3}>
            <VuiBox
              display="flex"
              flexDirection="column"
              justifyContent="space-between"
              height="100%"
            >
              <VuiBox mb={1.3}>
                <VuiBox display="flex" alignItems="center" gap={1.2} mb={1}>
                  <VuiBox
                    sx={{
                      width: 42,
                      height: 42,
                      borderRadius: "14px",
                      background: "#dec8b3",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <IoBusiness size={18} />
                  </VuiBox>

                  <VuiTypography variant="h6" fontWeight="bold">
                    {selectedHotel?.name || "Hotel"}
                  </VuiTypography>
                </VuiBox>

                {!!selectedHotel?.address && (
                  <VuiBox display="flex" alignItems="center" gap={1}>
                    <IoLocationSharp size={13} />

                    <VuiTypography variant="caption">{selectedHotel.address}</VuiTypography>
                  </VuiBox>
                )}
              </VuiBox>

              <VuiBox mt={0}>
                <VuiBox
                  sx={{
                    pr: 2,
                    width: "100%",
                    "& .MuiAutocomplete-root": {
                      width: "100%",
                    },
                  }}
                >
                  <HotelSelector multiple={false} fullWidth width="100%" minWidth={0} />
                </VuiBox>
              </VuiBox>
            </VuiBox>
          </Grid>

          {/* KPI GRID */}
          <Grid item xs={12} lg={9}>
            <Grid container spacing={2}>
              {kpis.map((item, index) => (
                <Grid item xs={12} sm={6} md={3} key={index}>
                  <KpiCard
                    title={item.title}
                    value={item.value}
                    icon={item.icon}
                    sub={item.sub}
                    color={item.color}
                    loading={countersLoading}
                    onClick={item.route ? () => NAVIGATE(item.route) : undefined}
                  />
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </VuiBox>
    </Card>
  );
}

export default DashboardPropertyHeader;
